import { useMemo, useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { toolRoutes } from '@/routes/siteMaps';
import RouteHelperAlerts from '@/components/common/RouteHelperAlerts';
import ToolsBreadcrumb from '@/app/common/components/ToolsBreadcrumb';
import ToolTabs from '@/app/common/components/ToolTabs';
import useDomain from '@/hooks/useDomain';
import SubtleBadge from '@/components/common/SubtleBadge';

const ContentToolsLayout = () => {
  const { domain, domain_slug } = useDomain();
  const { slug } = useParams();
  const location = useLocation();
  const analysisId = slug && slug !== 'last' ? slug : 'last';

  const [breadcrumbData, setBreadcrumbData] = useState([]);

  const contentTools = toolRoutes.children.find(
    item => item.name === 'ابزار محتوا'
  );
  const aiAnalysis = contentTools?.children?.find(
    item => item.name === 'تحلیل AI'
  );

  const navItems = aiAnalysis;

  const tabPath = route => {
    if (route.disabled) return '#!';
    if (route.to?.includes('history')) {
      return `${route.to}/${domain_slug}/${domain}`;
    }
    return `${route.to}/${domain_slug}/${domain}/${analysisId}`;
  };

  const isRouteActive = (route, pathname, navLinkActive = false) => {
    if (navLinkActive) return true;
    if (!route.to) return false;
    return pathname.includes(route.to);
  };

  const activePage = useMemo(
    () =>
      navItems?.children?.find(route =>
        isRouteActive(route, location.pathname)
      ),
    [navItems, location.pathname]
  );

  return (
    <>
      <ToolsBreadcrumb
        parentName="تحلیل AI"
        parentUrl={`/content-tools/ai-analysis/history/${domain_slug}/${domain}`}
        childs={breadcrumbData}
      />

      <ToolTabs
        items={(navItems?.children ?? []).map(route => ({
          key: route.to,
          label: route.name,
          to: tabPath(route),
          disabled: Boolean(route.disabled),
          state: { path: location.pathname, query: null },
          active: isRouteActive(route, location.pathname),
          badge: route?.badge ? (
            <SubtleBadge bg={route.badge.type} className="ms-1">
              {route.badge?.text}
            </SubtleBadge>
          ) : undefined
        }))}
      />

      {activePage && <RouteHelperAlerts route={activePage} />}

      <Outlet context={[breadcrumbData, setBreadcrumbData]} />
    </>
  );
};

export default ContentToolsLayout;
